import React from "react";
import PropTypes from "prop-types";
import Col from "antd/es/col";

const DetailsColumn = ({ label, value, col = 8, valueStyle = {} }) => (
  <Col span={col}>
    <span className="details-label">{label}</span>
    <Col>
      <span className="details-value" style={valueStyle}>
        {value}
      </span>
    </Col>
  </Col>
);

DetailsColumn.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

export default DetailsColumn;
